// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-checkbox {
  position: relative;
  width: 100%;
  text-align: left;
  float: left;
  clear: both;
}
.srprs-checkbox-wrapper {
  display: inline-block;
}
.srprs-checkbox input {
  position: absolute;
  opacity: 0;
  top: 17px;
  left: 6px;
}
.srprs-checkbox input:checked + label:after {
  animation: grow-checkbox 600ms normal;
}
.srprs-checkbox input:checked + label .srprs-icon {
  color: var(--colorBackground);
}
.srprs-checkbox input:checked + label .srprs-icon svg {
  opacity: 1;
  transform: scale(1);
}
.srprs-checkbox input:checked + label .srprs-icon:before {
  border-color: var(--colorBackground);
}
.srprs-checkbox label {
  width: 100%;
  display: inline-block;
  position: relative;
  line-height: 26px;
  cursor: pointer;
  padding-left: 28px;
  padding-right: 10px;
  margin-top: 2px;
  margin-right: 0px;
  margin-bottom: 2px;
  margin-left: 0px;
}
.srprs-checkbox label:before {
  width: 100%;
  height: 100%;
  display: inline-block;
  position: absolute;
  opacity: 0;
  content: "";
  z-index: 1;
  top: 0;
  left: 0;
  transition: all 300ms cubic-bezier(0.175, 0.885, 0.32, 1.75);
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  margin-left: 0px;
  background-color: #f4f4f4;
}
.srprs-checkbox label:after {
  width: 25px;
  height: 25px;
  display: inline-block;
  position: absolute;
  content: "";
  z-index: 1;
  top: 0;
  left: 0;
  opacity: 0;
  background-color: var(--colorBackground);
}
.srprs-checkbox label > span:first-child {
  display: block;
  position: relative;
  z-index: 2;
}
.srprs-checkbox label small {
  position: relative;
  z-index: 2;
  font-style: italic;
  margin-left: 4px;
}
.srprs-checkbox label .srprs-icon {
  width: 15px;
  height: 15px;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  margin-top: 5px;
  margin-left: 5px;
}
.srprs-checkbox label .srprs-icon svg {
  width: 100%;
  height: auto;
  opacity: 0;
  position: relative;
  z-index: 2;
  transform: scale(0);
}
.srprs-checkbox label .srprs-icon svg * {
  fill: currentColor;
}
.srprs-checkbox label .srprs-icon:before {
  width: 25px;
  height: 25px;
  display: inline-block;
  position: absolute;
  content: "";
  z-index: 3;
  top: -5px;
  left: -5px;
  pointer-events: none;
  border-width: 1px;
  border-color: #e7e7e7;
  border-style: solid;
}
.srprs-checkbox label .srprs-icon:after {
  width: 25px;
  height: 25px;
  display: inline-block;
  position: absolute;
  content: "";
  z-index: 1;
  top: -5px;
  left: -5px;
  background-color: white;
}
.srprs-checkbox label:hover:before {
  width: calc(100% + 20px);
  height: calc(100% + 20px);
  opacity: 1;
  margin-top: -10px;
  margin-right: -10px;
  margin-bottom: -10px;
  margin-left: -10px;
}
.srprs-checkbox label:hover .srprs-icon {
  color: #cecece;
}
.srprs-checkbox label:hover .srprs-icon svg {
  opacity: 1;
  transform: scale(1);
}
.srprs-checkbox input[type=radio] + label .srprs-icon:before, .srprs-checkbox input[type=radio] + label:before, .srprs-checkbox input[type=radio] + label:after {
  width: 20px;
  height: 20px;
  transition: all 300ms ease-in-out;
  margin-top: 3px;
  margin-left: 1px;
  border-width: 4px;
  border-style: solid;
  border-color: #fff;
  border-radius: 50%;
  box-shadow: 0px 0px 0px 1px #d3d3d3;
}
.srprs-checkbox input[type=radio] + label:before {
  opacity: 0;
  background-color: var(--colorBackground);
}
.srprs-checkbox input[type=radio] + label:after {
  transform: none;
  background-color: transparent;
  border-color: var(--colorBackground);
}
.srprs-checkbox input[type=radio] + label .srprs-icon svg,
.srprs-checkbox input[type=radio] + label .srprs-icon:after {
  display: none;
}
.srprs-checkbox input[type=radio] + label:hover:before {
  opacity: 0.3;
  margin-top: 3px;
  margin-right: 0px;
  margin-bottom: 0px;
  margin-left: 0px;
}
.srprs-checkbox input[type=radio]:checked + label .srprs-icon:before {
  background-color: var(--colorBackground);
}
.srprs-checkbox input[type=radio]:disabled + label {
  color: #bfbfbf;
}
.srprs-checkbox-wrapper.type-horizontal .srprs-checkbox {
  width: auto;
  clear: none;
}
.srprs-checkbox-wrapper.type-horizontal .srprs-checkbox:not(:last-child) {
  margin-right: 20px;
}
.srprs-checkbox-wrapper.type-tiles .srprs-checkbox label:before,
.srprs-checkbox-wrapper.type-tiles .srprs-checkbox label:after,
.srprs-checkbox-wrapper.type-tiles .srprs-checkbox .srprs-icon {
  display: none;
}
.srprs-checkbox-wrapper.type-tiles .srprs-checkbox label {
  width: auto;
  line-height: 20px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 100px;
  padding-top: 10px;
  padding-right: 20px;
  padding-bottom: 10px;
  padding-left: 20px;
  margin-top: 0px;
  margin-right: 8px;
  margin-bottom: 8px;
  margin-left: 0px;
}
.srprs-checkbox-wrapper.type-tiles .srprs-checkbox input:checked + label {
  background-color: var(--colorBackground);
  box-shadow: none;
}
.srprs-checkbox-wrapper.type-tiles.type-horizontal .srprs-checkbox:not(:last-child) {
  margin-right: 0px;
}
.srprs-checkbox.checkbox-box {
  box-shadow: 0 0 12px 0 rgba(34, 34, 34, 0.15);
  list-style: none;
}
.srprs-checkbox.checkbox-box label {
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
  background-color: #fff;
  color: #222;
  padding-left: 20px;
  padding-top: 15px;
  padding-right: 10px;
  padding-bottom: 15px;
  margin: 0;
}
.srprs-checkbox.checkbox-box label span {
  text-transform: uppercase;
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-size: 13px;
  font-weight: 700;
}
.srprs-checkbox.checkbox-box label .srprs-icon {
  opacity: 0;
}
.srprs-checkbox.checkbox-box label .srprs-icon::before {
  border: none;
}
.srprs-checkbox.checkbox-box label::before {
  opacity: 1;
  z-index: 2;
  top: 26px;
  left: 16px;
  width: 90px;
  height: 1px;
  background: transparent;
  margin: 0;
  border-top: 3px solid #f87498;
  transform: rotate(-5deg);
}
.srprs-checkbox.checkbox-box input:checked + label:before {
  opacity: 0;
}
.srprs-checkbox.checkbox-box input:disabled + label {
  cursor: not-allowed;
}
.srprs-checkbox.checkbox-box input:disabled + label:before {
  opacity: 0;
}
.srprs-checkbox.checkbox-box input:disabled + label:hover {
  animation-name: buttonDisabled;
  animation-fill-mode: both;
  animation-duration: 0.75s;
  animation-timing-function: cubic-bezier(0.36, 0.07, 0.19, 0.97);
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}
@media screen and (min-width: 768px) {
  .srprs-checkbox.checkbox-box label {
    padding-left: 50px;
    padding-top: 27px;
    padding-right: 10px;
    padding-bottom: 27px;
  }
  .srprs-checkbox.checkbox-box label span {
    font-size: 18px;
  }
  .srprs-checkbox.checkbox-box label .srprs-icon {
    margin-top: 33px;
    margin-left: 25px;
  }
  .srprs-checkbox.checkbox-box label::before {
    top: 37px;
    left: 36px;
    width: 110px;
  }
  .srprs-checkbox.checkbox-box input:checked + label .srprs-icon {
    opacity: 1;
  }
}
@media screen and (min-width: 1280px) {
  .srprs-checkbox.checkbox-box label:hover {
    transform: scale(1.02);
  }
  .srprs-checkbox.checkbox-box label:hover::before {
    opacity: 1;
    border-color: #222;
  }
  .srprs-checkbox.checkbox-box input:checked + label:before {
    opacity: 1;
  }
  .srprs-checkbox.checkbox-box input:checked + label:hover .srprs-icon {
    opacity: 0;
  }
  .srprs-checkbox.checkbox-box input:checked + label:not(:hover):before {
    opacity: 0;
  }
}
@keyframes grow-checkbox {
  0% {
    transform: scale(0);
    opacity: 0.6;
  }
  100% {
    transform: scale(2);
    filter: blur(1px);
    border-radius: 10px;
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/Checkboxes/Checkboxes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_box-shadow.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_transition.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AArMA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;AAuMF;AAtME;EACE,qBAAA;AAwMJ;AAtME;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AAwMJ;AArMI;EACE,qCAAA;AAuMN;AArMI;EACE,6BAAA;AAuMN;AAtMM;EACE,UAAA;EACA,mBAAA;AAwMR;AAtMM;EAEI,oCAAA;AAuMV;AAlME;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EAEE,kBAAA;EACA,mBAAA;EAGA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAiMN;AA/LI;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,4DAAA;EAEE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EAGA,yBAAA;AA8LR;AA3LI;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EAEE,wCAAA;AA4LR;AAzLI;EACE,cAAA;EACA,kBAAA;EACA,UAAA;AA2LN;AAzLI;EACE,kBAAA;EACA,UAAA;EAEE,kBAAA;EAGA,gBAAA;AAwLR;AArLI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EAEE,eAAA;EACA,gBAAA;AAsLR;AApLM;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;AAsLR;AArLQ;EACE,kBAAA;AAuLV;AApLM;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EAEE,iBAAA;EACA,qBAAA;EACA,mBAAA;AAqLV;AAlLM;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EAGE,uBAAA;AAkLV;AA7KM;EACE,wBAAA;EACA,yBAAA;EACA,UAAA;EAEE,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AA8KV;AA3KM;EACE,cAAA;AA6KR;AA5KQ;EACE,UAAA;EACA,mBAAA;AA8KV;AAtKI;EAGE,WAAA;EACA,YAAA;EACA,iCAAA;EAEE,eAAA;EACA,gBAAA;EAGA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EAEF,mCAAA;AAkKN;AAhKI;EACE,UAAA;EAEE,wCAAA;AAiKR;AA9JI;EACE,eAAA;EAEE,6BAAA;EAGA,oCAAA;AA6JR;AA1JI;;EAEE,aAAA;AA4JN;AAzJM;EACE,YAAA;EAEE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AA0JV;AApJI;EAEI,wCAAA;AAqJR;AAjJE;EACE,cAAA;AAmJJ;AA7II;EACE,WAAA;EACA,WAAA;AA+IN;AA9IM;EAEI,kBAAA;AA+IV;AArIM;;;EAGE,aAAA;AAuIR;AArIM;EACE,WAAA;EACA,iBAAA;EAEE,sBAAA;EAGA,uCAAA;EAGA,oBAAA;EAGA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EAGA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AA8HV;AA3HM;EAEI,wCAAA;EAGA,gBAAA;AA0HV;AArHM;EAEI,iBAAA;AAsHV;AA9GE;EIrSE,6CAAA;EJwSA,gBAAA;AA+GJ;AA9GI;EKnTA,wBAAA;EACA,0BLmTsB;EKlTtB,oCAAA;EAEE,oBANqD;ELuTrD,sBAAA;EACA,WAAA;EAEE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EAEF,SAAA;AAiHN;AA/GM;EACE,yBAAA;EAEE,2IAAA;EACA,eAAA;EACA,gBAAA;AAgHV;AA5GM;EACE,UAAA;AA8GR;AA7GQ;EACE,YAAA;AA+GV;AA3GM;EACE,UAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;EACA,6BAAA;EACA,wBAAA;AA6GR;AAxGM;EACE,UAAA;AA0GR;AAtGI;EACE,mBAAA;AAwGN;AAtGM;EACE,UAAA;AAwGR;AArGM;EAEI,8BAAA;EACA,yBAAA;EACA,yBAAA;EACA,+DAAA;EAEF,+BAAA;EACA,2BAAA;EACA,mBAAA;AAqGR;ACtdI;EDsXE;IAEI,kBAAA;IACA,iBAAA;IACA,mBAAA;IACA,oBAAA;EAkGR;EA/FM;IACE,eAAA;EAiGR;EA9FM;IAEI,gBAAA;IACA,iBAAA;EA+FV;EA3FM;IACE,SAAA;IACA,UAAA;IACA,YAAA;EA6FR;EAxFM;IACE,UAAA;EA0FR;AACF;AC7eI;EDyZI;IACE,sBAAA;EAuFR;EArFQ;IACE,UAAA;IACA,kBAAA;EAuFV;EAjFM;IACE,UAAA;EAmFR;EAhFQ;IACE,UAAA;EAkFV;EA9EQ;IACE,UAAA;EAgFV;AACF;AAzEE;EACE;IACE,mBAAA;IACA,YAAA;EA2EJ;EAzEE;IACE,mBAAA;IACA,iBAAA;IACA,mBAAA;IACA,UAAA;EA2EJ;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n\n.srprs-checkbox {\n  position: relative;\n  width: 100%;\n  text-align: left;\n  float: left;\n  clear: both;\n  &-wrapper {\n    display: inline-block;\n  }\n  input {\n    position: absolute;\n    opacity: 0;\n    top: 17px;\n    left: 6px;\n  }\n  input:checked + label {\n    &:after {\n      animation: grow-checkbox 600ms normal;\n    }\n    .srprs-icon {\n      color: var(--colorBackground);\n      svg {\n        opacity: 1;\n        transform: scale(1);\n      }\n      &:before {\n        border: {\n          color: var(--colorBackground);\n        }\n      }\n    }\n  }\n  label {\n    width: 100%;\n    display: inline-block;\n    position: relative;\n    line-height: 26px;\n    cursor: pointer;\n    padding: {\n      left: 28px;\n      right: 10px;\n    }\n    margin: {\n      top: 2px;\n      right: 0px;\n      bottom: 2px;\n      left: 0px;\n    }\n    &:before {\n      width: 100%;\n      height: 100%;\n      display: inline-block;\n      position: absolute;\n      opacity: 0;\n      content: '';\n      z-index: 1;\n      top: 0;\n      left: 0;\n      transition: all 300ms cubic-bezier(0.175, 0.885, 0.32, 1.75);\n      margin: {\n        top: 0px;\n        right: 0px;\n        bottom: 0px;\n        left: 0px;\n      }\n      background: {\n        color: lighten(color(grey-light), 5%);\n      }\n    }\n    &:after {\n      width: 25px;\n      height: 25px;\n      display: inline-block;\n      position: absolute;\n      content: '';\n      z-index: 1;\n      top: 0;\n      left: 0;\n      opacity: 0;\n      background: {\n        color: var(--colorBackground);\n      }\n    }\n    > span:first-child {\n      display: block;\n      position: relative;\n      z-index: 2;\n    }\n    small {\n      position: relative;\n      z-index: 2;\n      font: {\n        style: italic;\n      }\n      margin: {\n        left: 4px;\n      }\n    }\n    .srprs-icon {\n      width: 15px;\n      height: 15px;\n      position: absolute;\n      z-index: 1;\n      top: 0;\n      left: 0;\n      margin: {\n        top: 5px;\n        left: 5px;\n      }\n      svg {\n        width: 100%;\n        height: auto;\n        opacity: 0;\n        position: relative;\n        z-index: 2;\n        transform: scale(0);\n        * {\n          fill: currentColor;\n        }\n      }\n      &:before {\n        width: 25px;\n        height: 25px;\n        display: inline-block;\n        position: absolute;\n        content: '';\n        z-index: 3;\n        top: -5px;\n        left: -5px;\n        pointer-events: none;\n        border: {\n          width: 1px;\n          color: color(grey-light);\n          style: solid;\n        }\n      }\n      &:after {\n        width: 25px;\n        height: 25px;\n        display: inline-block;\n        position: absolute;\n        content: '';\n        z-index: 1;\n        top: -5px;\n        left: -5px;\n        // opacity: 0;\n        background: {\n          color: white;\n        }\n      }\n    }\n    &:hover {\n      &:before {\n        width: calc(100% + 20px);\n        height: calc(100% + 20px);\n        opacity: 1;\n        margin: {\n          top: -10px;\n          right: -10px;\n          bottom: -10px;\n          left: -10px;\n        }\n      }\n      .srprs-icon {\n        color: darken(color(grey-light), 10%);\n        svg {\n          opacity: 1;\n          transform: scale(1);\n        }\n      }\n    }\n  }\n\n  // radios\n  input[type='radio'] + label {\n    .srprs-icon:before,\n    &:before,\n    &:after {\n      width: 20px;\n      height: 20px;\n      transition: all 300ms ease-in-out;\n      margin: {\n        top: 3px;\n        left: 1px;\n      }\n      border: {\n        width: 4px;\n        style: solid;\n        color: color(white);\n        radius: 50%;\n      }\n      box-shadow: 0px 0px 0px 1px color(grey);\n    }\n    &:before {\n      opacity: 0;\n      background: {\n        color: var(--colorBackground);\n      }\n    }\n    &:after {\n      transform: none;\n      background: {\n        color: transparent;\n      }\n      border: {\n        color: var(--colorBackground);\n      }\n    }\n    .srprs-icon svg,\n    .srprs-icon:after {\n      display: none;\n    }\n    &:hover {\n      &:before {\n        opacity: 0.3;\n        margin: {\n          top: 3px;\n          right: 0px;\n          bottom: 0px;\n          left: 0px;\n        }\n      }\n    }\n  }\n  input[type='radio']:checked + label {\n    .srprs-icon:before {\n      background: {\n        color: var(--colorBackground);\n      }\n    }\n  }\n  input[type='radio']:disabled + label {\n    color: lighten(black, 75%);\n  }\n  // @end: radios\n\n  // Horizontal list\n  &-wrapper.type-horizontal {\n    .srprs-checkbox {\n      width: auto;\n      clear: none;\n      &:not(:last-child) {\n        margin: {\n          right: 20px;\n        }\n      }\n    }\n  }\n  // @end: Horizontal list\n\n  // Tiles list\n  &-wrapper.type-tiles {\n    .srprs-checkbox {\n      label:before,\n      label:after,\n      .srprs-icon {\n        display: none;\n      }\n      label {\n        width: auto;\n        line-height: 20px;\n        background: {\n          color: color(white);\n        }\n        box: {\n          shadow: 0 0 10px rgba(#000, 0.1);\n        }\n        border: {\n          radius: 100px;\n        }\n        padding: {\n          top: 10px;\n          right: 20px;\n          bottom: 10px;\n          left: 20px;\n        }\n        margin: {\n          top: 0px;\n          right: 8px;\n          bottom: 8px;\n          left: 0px;\n        }\n      }\n      input:checked + label {\n        background: {\n          color: var(--colorBackground);\n        }\n        box: {\n          shadow: none;\n        }\n      }\n    }\n    &.type-horizontal {\n      .srprs-checkbox:not(:last-child) {\n        margin: {\n          right: 0px;\n        }\n      }\n    }\n  }\n  // @end: Tiles list\n\n  // Strike-through\n  &.checkbox-box {\n    @include box-shadow();\n\n    list-style: none;\n    label {\n      @include transition(0.25s);\n      background-color: color(white);\n      color: color(black);\n      padding: {\n        left: 20px;\n        top: 15px;\n        right: 10px;\n        bottom: 15px;\n      }\n      margin: 0;\n\n      span {\n        text-transform: uppercase;\n        font: {\n          family: font(heading);\n          size: 13px;\n          weight: 700;\n        }\n      }\n\n      .srprs-icon {\n        opacity: 0;\n        &::before {\n          border: none;\n        }\n      }\n\n      &::before {\n        opacity: 1;\n        z-index: 2;\n        top: 26px;\n        left: 16px;\n        width: 90px;\n        height: 1px;\n        background: transparent;\n        margin: 0;\n        border-top: 3px solid color(pink);\n        transform: rotate(-5deg);\n      }\n    }\n\n    input:checked + label {\n      &:before {\n        opacity: 0;\n      }\n    }\n\n    input:disabled + label {\n      cursor: not-allowed;\n\n      &:before {\n        opacity: 0;\n      }\n\n      &:hover {\n        animation: {\n          name: buttonDisabled;\n          fill-mode: both;\n          duration: 0.75s;\n          timing-function: cubic-bezier(0.36, 0.07, 0.19, 0.97);\n        }\n        transform: translate3d(0, 0, 0);\n        backface-visibility: hidden;\n        perspective: 1000px;\n      }\n    }\n\n    @include breakpoint(tablet-portrait) {\n      label {\n        padding: {\n          left: 50px;\n          top: 27px;\n          right: 10px;\n          bottom: 27px;\n        }\n\n        span {\n          font-size: 18px;\n        }\n\n        .srprs-icon {\n          margin: {\n            top: 33px;\n            left: 25px;\n          }\n        }\n\n        &::before {\n          top: 37px;\n          left: 36px;\n          width: 110px;\n        }\n      }\n\n      input:checked + label {\n        .srprs-icon {\n          opacity: 1;\n        }\n      }\n    }\n\n    @include breakpoint(desktop) {\n      label {\n        &:hover {\n          transform: scale(1.02);\n\n          &::before {\n            opacity: 1;\n            border-color: color(black);\n          }\n        }\n      }\n\n      input:checked + label {\n        &:before {\n          opacity: 1;\n        }\n        &:hover {\n          .srprs-icon {\n            opacity: 0;\n          }\n        }\n        &:not(:hover) {\n          &:before {\n            opacity: 0;\n          }\n        }\n      }\n    }\n  }\n  // @end: Strike-through\n\n  @keyframes grow-checkbox {\n    0% {\n      transform: scale(0);\n      opacity: 0.6;\n    }\n    100% {\n      transform: scale(2);\n      filter: blur(1px);\n      border-radius: 10px;\n      opacity: 0;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n$box-shadow: map-deep-get($srprsreactwebsite-config, 'box-shadow');\n\n@mixin box-shadow(\n  $blur: map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n) {\n  @if map-has-key($box-shadow, $blur) {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', $blur)\n      0\n      rgba(color(black), 0.15);\n  } @else {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n      0\n      rgba(color(black), 0.15);\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin transition($transition-duration, $transition-delay: 0s) {\n  transition: {\n    property: all;\n    duration: $transition-duration;\n    timing-function: ease-out;\n    @if $transition-delay {\n      delay: $transition-delay;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
